<div class="footer-background">LB Foster. All rights reserved</div>
